import React from "react";
import { getCardImage } from "../resultVisuals/cardAssets";

const WINNER_IMG = `${import.meta.env.BASE_URL}img/winner.png`;

const PLAYERS = [
  { name: "Tiger", idx: [0, 3, 6], win: "1" },
  { name: "Lion", idx: [1, 4, 7], win: "2" },
  { name: "Dragon", idx: [2, 5, 8], win: "3" },
];

/**
 * Reference result body for Teenpatti Test (teen9):
 * .row.row5.dtl20-result.text-center > 3 × .col-12.col-lg-3 (Tiger/Lion/Dragon cards, trophy before
 * the winner's) + .col-12.col-lg-3 .casino-result-desc (Winner = rdesc[0], Others = rdesc[1]).
 */
export default function Teen9ResultBody({ t1 }) {
  const cards = String(t1?.card || "").split(",").map((c) => c.trim());
  const win = String(t1?.win ?? "");
  const desc = t1?.rdesc ? String(t1.rdesc).split("#") : [];

  return (
    <div className="row row5 dtl20-result text-center">
      {PLAYERS.map((p) => (
        <React.Fragment key={p.name}>
          <div className="col-12 col-lg-3">
            <div className="casino-result-cards">
              {win === p.win && (
                <div className="casino-result-cards-item">
                  <img src={WINNER_IMG} className="winner-icon" />
                </div>
              )}{" "}
              <div className="d-inline-block">
                <h4 className="text-center">{p.name}</h4>
                {p.idx.map((i) => (
                  <React.Fragment key={i}>
                    {" "}
                    <div className="casino-result-cards-item">
                      <img src={getCardImage(cards[i])} />
                    </div>
                  </React.Fragment>
                ))}
              </div>
            </div>
          </div>{" "}
        </React.Fragment>
      ))}
      <div className="col-12 col-lg-3">
        {desc.length > 0 && (
          <div className="casino-result-desc">
            <div className="casino-result-desc-item">
              <div>Winner</div> <div>{desc[0]}</div>
            </div>{" "}
            <div className="casino-result-desc-item">
              <div>Others</div> <div>{desc[1]}</div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
